import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-integration-error',
  templateUrl: './integration-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IntegrationErrorComponent {
}
